import {
  UPDATE_VISIBLE_LAYERS,
  SET_MAPVIEW_READY,
  SET_RIVER_TOOL_ACTIVE,
  SET_SKETCH_TOOL_ACTIVE,
  SET_SWIPE_TOOL_ACTIVE,
  SET_ANNOTATION_TOOL_ACTIVE,
  SET_LAYER_MODAL_ACTIVE,
  SET_DRAW_COMPLETE,
  UPDATE_ANNOTATIONS,
  SET_CONTEXTUAL_TOOL_ACTIVE,
  UPDATE_MY_LAYERS,
  TOGGLE_MAP_LOADER,
  UPDATE_PERFORM_AUDIT_LAYERS,
  STORE_TEMP_GRAPHIC,
  SET_TOAST_ERROR,
  UPDATE_THRESHOLDS,
  SET_RENDERING_RULE,
  SET_TIMESLIDERS_ENABLED,
  UPDATE_DISABLED_LAYERS,
} from '../../constants/appTypes';

import { IPerformAuditCriteriaData } from '../../types/auditdata';

export function setTimeSlidersEnabled(timeSlidersEnabled: boolean) {
  return {
    type: SET_TIMESLIDERS_ENABLED,
    timeSlidersEnabled
  };
}

export function updateVisibleLayers(visibleLayers: Array<string>) {
  return {
    type: UPDATE_VISIBLE_LAYERS,
    visibleLayers,
  };
}

export function updateDisabledLayers(disabledLayers: Array<string>) {
  return {
    type: UPDATE_DISABLED_LAYERS,
    disabledLayers,
  };
}

export function setMapReady(ready: boolean) {
  return {
    type: SET_MAPVIEW_READY,
    ready,
  };
}

export function setSketchToolActive(active: boolean) {
  return {
    type: SET_SKETCH_TOOL_ACTIVE,
    active,
  };
}

export function setSwipeToolActive(active: boolean) {
  return {
    type: SET_SWIPE_TOOL_ACTIVE,
    active,
  };
}

export function setRiverSketchToolActive(active: boolean) {
  return {
    type: SET_RIVER_TOOL_ACTIVE,
    active,
  };
}

export function setContextualSketchToolActive(active: boolean) {
  return {
    type: SET_CONTEXTUAL_TOOL_ACTIVE,
    active,
  };
}

export function updateMyLayers(myLayers: Array<__esri.GraphicsLayer>) {
  return {
    type: UPDATE_MY_LAYERS,
    myLayers,
  };
}

export function setAnnotationToolActive(active: boolean) {
  return {
    type: SET_ANNOTATION_TOOL_ACTIVE,
    active,
  };
}

export function setDrawComplete(complete: boolean) {
  return {
    type: SET_DRAW_COMPLETE,
    complete,
  };
}

export function updateAnnotations(annotations: Array<__esri.Graphic>) {
  return {
    type: UPDATE_ANNOTATIONS,
    annotations,
  };
}

export const toggleMapLoader = (active: boolean) => {
  return {
    type: TOGGLE_MAP_LOADER,
    active,
  };
};

export function updatePerformAuditLayers(performAuditLayers: Array<IPerformAuditCriteriaData>) {
  return {
    type: UPDATE_PERFORM_AUDIT_LAYERS,
    performAuditLayers,
  };
}

export const toggleLayerModal = (active: boolean, layerTitle?: string, deleteLayer?: boolean) => {
  return {
    type: SET_LAYER_MODAL_ACTIVE,
    active,
    layerTitle,
    deleteLayer,
  };
};

export const storeTempGraphic = (graphic: __esri.Graphic | null) => {
  return {
    type: STORE_TEMP_GRAPHIC,
    graphic,
  };
};

export const toggleToastError = (error: boolean, msg: string) => {
  return {
    type: SET_TOAST_ERROR,
    error,
    msg,
  };
};

export const setRasterThreshold = (layerId: string, thresholdValue: Array<number>, min: number, max: number) => {
  return {
    type: UPDATE_THRESHOLDS,
    layerId,
    thresholdValue,
    min,
    max,
  };
};

export const setRenderingRule = (layerID: string, renderingRule: string) => {
  return {
    type: SET_RENDERING_RULE,
    layerID,
    renderingRule
  }
}